// extracted by mini-css-extract-plugin
export default {"newsNav":"index_newsNav_ONcAP","newsSpec":"index_newsSpec_UdXJJ","current":"index_current_3UCQy","conNav":"index_conNav_mE3UE"};